/* eslint-disable */
import { ReactComponent as AdministrationIcon } from '../../../assets/svgIcons/administrationIcon.svg'
import { ReactComponent as BusinessInsightsIcon } from '../../../assets/svgIcons/businessInsightsIcon.svg'
import { ReactComponent as ReportesIcon } from '../../../assets/svgIcons/reportesIcon.svg'
import { ReactComponent as AjustesIcon } from '../../../assets/svgIcons/ajustesIcon.svg'
import { ReactComponent as ChatIcon } from '../../../assets/svgIcons/chatIcon.svg'
import { ReactComponent as ContadorIcon } from '../../../assets/svgIcons/1Recurso17.svg'
import { ReactComponent as FacturacionIcon } from '../../../assets/iconosVinculaciones/3.svg'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import { MARKETING_REPORTS_ALLOWED_EMAILS } from '../../../constants/marketingReports'
// import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'

export const menuItemsDefaults = [
  {
    id: 1,
    name: 'Business Insights',
    icon: BusinessInsightsIcon,
    path: '/'
  },
  {
    id: 2,
    name: 'Administración',
    icon: AdministrationIcon,
    path: '/administracion'
  },
  // {
  //   id: 3,
  //   name: 'Inventario',
  //   icon: Inventory2OutlinedIcon,
  //   path: '/inventario'
  // },
  {
    id: 4,
    name: 'Reportes',
    icon: ReportesIcon,
    path: '/reportes'
  },
  {
    id: 5,
    name: 'Mi Contador',
    icon: ContadorIcon,
    path: '/micontador',
    requiredPermission: 'allowAccountingDesk'
  },
  {
    id: 6,
    name: 'TryLuca (AI)',
    icon: ChatIcon,
    path: '/chat'
  },
  {
    id: 8,
    name: 'Facturación',
    // badge: 'Pronto',
    path: '/facturacion',
    icon: FacturacionIcon,
    requiredPermission: 'allowIntelligentBilling'
  },
  {
    id: 9,
    name: 'Reportes Marketing',
    icon: CampaignOutlinedIcon,
    path: '/reportes-marketing',
    allowedEmails: MARKETING_REPORTS_ALLOWED_EMAILS
  },
  {
    id: 7,
    name: 'Ajustes',
    icon: AjustesIcon,
    path: '/ajustes'
  },
  {
    id: 8,
    name: 'Tickets',
    icon: SupportAgentIcon,
    path: '/tickets',
    showForAdmin: false,
    showForNonAdmin: false
  }
]
